import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { EpGridComponent, IEpGridModel, IEpGridState, IEPGridDataResult, EpGridEvent, IEpGridSelectionOptions, IEpComponentEventArg, EpEventService } from '@epicor/kinetic';
declare var $: any;
import { IEpBtCardControlModel, BistrackConfig, BranchAccess, CustomEvents } from 'ep-bt-controls';

import { ActivatedRoute } from '@angular/router';
import { FieldAgentClient, Branch } from 'ep-bt-field-agent-proxy';
import { Router, NavigationExtras } from '@angular/router';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { Location } from '@angular/common';
import { Rights } from '../../core-objects/Rights';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-product-stock-grid',
  templateUrl: './epbt-fa-product-stock-grid.component.html',
  styleUrls: ['./epbt-fa-product-stock-grid.component.scss']
})
export class EpbtFaProductStockGridComponent implements OnInit {

  constructor(private route: ActivatedRoute, private client: FieldAgentClient,
    private config: BistrackConfig, private productService: EpbtFaProductService,
    private router: Router, private faService: EpbtFieldAgentService, public quickOrderService: EpbtFaQuickOrderService, public epEvent: EpEventService) { }

  @Input() productId: number;
  products: any;
  data: any;
  productstock: any;
  branchID: number;
  @ViewChild(EpGridComponent, { static: false }) grid: EpGridComponent;
  @ViewChild('emptydecimalTemplate', { static: false }) emptydecimalTemplate: TemplateRef<any>;
  @ViewChild('emptydecimalTemplate2', { static: false }) emptydecimalTemplate2: TemplateRef<any>;

  showGrid = true;
  public gridModel: IEpGridModel;
  public pageSize: number;
  public cards: Array<IEpBtCardControlModel>;
  bistrackSettings: any;
  webTrackUser: any;
  branchId: number;
  customerId: number;
  stocks: any[] = [];

  branchIds: Array<any> = [];
  branchName: Array<any> = [];

  ngOnInit() {
    this.faService.getBisTrackSetting((bistrackSettings: any) => {
      this.bistrackSettings = bistrackSettings;
      this.pageSize = this.bistrackSettings.searchPageSize;
    });
    this.getBisTrackBranches();
    this.gridModel = this.getGridModel();
  }
  getBisTrackBranches() {
    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      this.client.getBisTrackBranches(webTrackUser, BranchAccess.Read).subscribe(res => {

        res.forEach(data => {
          this.branchIds.push(data.branchID);
          this.branchName.push(data.name);
        });

        this.getStocksData();


      });
    });
  }
  // api call start

  getStocksData() {

    let branchIndex = 0;
    const result = this.webTrackUser.rights.filter(x => x.name == Rights.ViewOnlyMyTradingBranch.name);
    if (result.length <= 0) {

      this.client.getProductStockLevel(this.productId, branchIndex).subscribe(rightsRes => {
        rightsRes['branchId'] = this.branchIds[branchIndex];
        rightsRes['name'] = 'All Branches';
        this.stocks.push(rightsRes);
        this.client.getProductStockLevels(this.productId, this.branchIds).subscribe(res => {
          if (res != null) {
            res.forEach(branchStock => {
              branchStock['branchId'] = this.branchIds[branchIndex];
              branchStock['name'] = this.branchName[branchIndex++];
              this.stocks.push(branchStock);
            });
            this.gridModel.data = this.stocks;
          }
        });
      });
    } else {
      this.client.getProductStockLevels(this.productId, this.branchIds).subscribe(res => {
        if (res != null) {
          res.forEach(branchStock => {
            branchStock['branchId'] = this.branchIds[branchIndex];
            branchStock['name'] = this.branchName[branchIndex++];
            this.stocks.push(branchStock);
          });
          this.gridModel.data = this.stocks;
        }
      });
    }



  }

  // api call end


  // grid model start
  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'productCode',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: true,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      // data: this.gridModel.data,
      columns: [
        { field: 'name', title: 'NAME', width: 80, hidden: false },
        { field: 'totalStock.perCode', title: 'STOCK UOM', width: 100, hidden: false },
        { field: 'totalStock.actual', title: 'ACTUAL', width: 80, hidden: false },
        { field: 'totalStock.available', title: 'AVAILABLE', width: 100, hidden: false, cellTemplate: this.emptydecimalTemplate },
        { field: 'totalStock.allocated', title: 'ALLOCATED', width: 80, hidden: false, cellTemplate: this.emptydecimalTemplate2 },
        { field: 'totalStock.awaitingProcessing', title: 'AWAITING PROCESSING', width: 100, hidden: false },
        { field: 'totalStock.onOrder', title: 'ON ORDER', width: 80, hidden: false },
        { field: 'totalStock.reserved', title: 'RESERVED', width: 100, hidden: false }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          this.navigateToProductStockDetailsView(eventArg.event.dataItem);
        }
      },
      // fnEvent: (event: EpGridEvent, args: any) => {
      //   if (event === EpGridEvent.cellClick) {
      //     this.navigateToProductStockDetailsView(args.dataItem);
      //   }
      // },
    };
    return model;
  }
  // grid model end


  // grid height calculation start
  getHeight(): number {
    const height = parseInt($('body').height());

    if (height > 900) {
      // return 300;
      return 700;
    } else { return 440; }// return 500;
  }
  // grid height calculation end


  // row click start

  navigateToProductStockDetailsView(args) {
    if (this.quickOrderService.isNewOrder) {
      this.productService.selectedStock = args;
      this.epEvent.broadcast(CustomEvents.NewQuickorderSelectedProductStockDetails);
    } else {
      this.productService.selectedStock = args;
      this.router.navigate(['/home/product/stockDetails']);
    }
  }

  onCardClick(model) {

    this.navigateToProductStockDetailsView(model);
  }
  // row click end


}

